module.exports = __webpack_public_path__ + "static/media/Report.7736d21f.pdf";